import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@app/shared';
import { TemplateRoutingModule } from './template-routing.module';
import { TemplateComponent } from './template.component';
import { HeaderNavigationComponent } from '@app/_v2/template/header-navigation/header-navigation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModalComponent } from '@app/_v2/template/modals/login/login-modal.component';
import { ForgotPasswordModalComponent } from '@app/_v2/template/modals/forgot-password/forgot-password-modal.component';
import { ResetPasswordModalComponent } from '@app/_v2/template/modals/reset-password/reset-password-modal.component';
import { SignupStep1ModalComponent } from '@app/_v2/template/modals/signup/1/signup-modal.component';
import { SignupStep2ModalComponent } from '@app/_v2/template/modals/signup/2/signup-modal.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SignupStep3ModalComponent } from '@app/_v2/template/modals/signup/3/signup-modal.component';
import { SignupStep4ModalComponent } from '@app/_v2/template/modals/signup/4/signup-modal.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { WithdrawModalComponent } from '@app/_v2/template/modals/withdraw/withdraw-modal.component';
import { WithdrawService } from '@app/core/account/withdraw.service';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
import { FiatService } from '@app/core/account/fiat.service';
import { ShapeShiftService } from '@app/core/account/shape-shift.service';
import { FairnessModalComponent } from '@app/_v2/template/modals/fairness/fairness-modal.component';
import { CountryRestrictionModule } from '@app/country-restriction/country-restriction.module';
import { JackpotHeaderComponent } from '@app/_v2/template/header-navigation/jackpot-header/jackpot-header.component';
import { OpenChestModalComponent } from '@app/_v2/template/modals/open-chest/open-chest-modal.component';
import { NotificationsModalComponent } from '@app/_v2/template/modals/notifications/notifications-modal.component';
import { JackpotEndedHeaderComponent } from '@app/_v2/template/header-navigation/jackpot-ended-header/jackpot-ended-header.component';
import { JackpotHeaderNewComponent } from '@app/_v2/template/header-navigation/jackpot-header-new/jackpot-header.component';
import { ChestWagerComponent } from '@app/_v2/template/header-navigation/chest-wager/chest-wager.component';
import { ChestWagerMobileComponent } from '@app/_v2/template/header-navigation/chest-wager-mobile/chest-wager.component';
import { OpenChestNewModalComponent } from '@app/_v2/template/modals/open-chest-new/open-chest-modal.component';
import { JackpotKeysModalComponent } from '@app/_v2/template/modals/jackpot-keys/jackpot-keys-modal.component';
import { JackpotFairnessModalComponent } from '@app/_v2/template/modals/jackpot-fairness/jackpot-fairness-modal.component';
import { GameRulesModalComponent } from './modals/game-rules/game-rules-modal.component';
import { WithdrawalModalGuard } from '@app/_v2/template/modals/withdraw/withdraw-modal.guard';
import { VerifyPhoneModalComponent } from '@app/_v2/template/modals/signup/verify-phone/verify-phone-modal.component';
import { DepositBonusComponent } from '@app/_v2/template/modals/deposit/deposit-bonus.component';
import { RECAPTCHA_SETTINGS, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { environment } from '@env/environment';
import { LegalModule } from '@app/_v2/legal/legal.module';
import { ConfirmWithdrawalModalComponent } from '@app/_v2/template/modals/confirm-withdrawal/confirm-withdrawal-modal.component';
import { ProofComponent } from '@app/_v2/template/proof/proof.component';
import { DepositModal2Component } from '@app/_v2/template/modals/deposit/deposit-modal-2.component';
import { DepositModalComponent } from '@app/_v2/template/modals/deposit/deposit-modal.component';
import { CurrencySelectorComponent } from '@app/_v2/template/modals/deposit/currency-selector.component';
import { WithdrawModal2Component } from '@app/_v2/template/modals/deposit/withdraw-modal-2.component';
import { FiatDepositComponent } from '@app/_v2/template/modals/deposit/fiat-deposit.component';
import { BalanceSelectorComponent } from '@app/_v2/template/header-navigation/balance-selector.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    // CoreModule,
    SharedModule,
    TemplateRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgxQRCodeModule,
    CountryRestrictionModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    LegalModule,
  ],
  declarations: [
    TemplateComponent,
    HeaderNavigationComponent,
    BalanceSelectorComponent,
    JackpotHeaderComponent,
    JackpotEndedHeaderComponent,
    JackpotHeaderNewComponent,
    JackpotKeysModalComponent,
    JackpotFairnessModalComponent,
    ChestWagerComponent,
    ChestWagerMobileComponent,
    LoginModalComponent,
    DepositModalComponent,
    DepositModal2Component,
    WithdrawModal2Component,
    WithdrawModalComponent,
    ForgotPasswordModalComponent,
    SignupStep1ModalComponent,
    SignupStep2ModalComponent,
    SignupStep3ModalComponent,
    SignupStep4ModalComponent,
    VerifyPhoneModalComponent,
    FairnessModalComponent,
    ResetPasswordModalComponent,
    OpenChestModalComponent,
    OpenChestNewModalComponent,
    NotificationsModalComponent,
    GameRulesModalComponent,
    DepositBonusComponent,
    ConfirmWithdrawalModalComponent,
    ProofComponent,
    CurrencySelectorComponent,
    FiatDepositComponent,
  ],
  entryComponents: [],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaKey,
        badge: 'inline',
        theme: 'dark',
        size: 'invisible',
      } as RecaptchaSettings,
    },
    ShapeShiftService,
    WithdrawService,
    BalanceHistoryService,
    FiatService,
    WithdrawalModalGuard,
  ],
})
export class TemplateModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/template.module.ts